import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concat, of } from 'rxjs';

import { NetworkCallService } from '../../../../app/core/services/network-call.service';
import { mergeMap, catchError, switchMap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import * as forgotPasscodeUserNeedsHelp from '../actions/forgot-passcode.actions';
import { IForgotPasscodeRequest, IForgotPasscodeResponse } from '../models/forgot-passcode.model';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';

@Injectable()
export class ForgotPasscodeEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  forgotPasscodeUserNeedsHelp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPasscodeUserNeedsHelp.loadForgotPasswordsUserNeedsHelpRequest),
      mergeMap(action =>
        this.networkCallService.post<IForgotPasscodeRequest, IForgotPasscodeResponse>('Authentication/forgotPasscode', action.request).pipe(
          switchMap(response => {
            if (
              response.success &&
              response.accessToken === null &&
              !response.showVerificationStep &&
              !response.locked
              // !response.userHasEmailAddress &&
              // !response.userHasFirstName
            ) {
              this.router.navigateByUrl('auth/forgot-passcode-otp');
            } else if (response.accessToken === null && response.success && response.showVerificationStep && !response.locked) {
              // signed up & ID entered
              this.router.navigateByUrl('auth/identification-check');
            } else if (
              // no sensitive information
              response.success &&
              response.accessToken !== null &&
              !response.showVerificationStep &&
              !response.locked
              // !response.userHasEmailAddress &&
              // !response.userHasFirstName
            ) {
              sessionStorage.setItem('token', response.accessToken);
              sessionStorage.setItem('refreshToken', response.refreshToken);
              this.helperService.decodeJwtToken(response.accessToken);
              this.router.navigateByUrl('auth/forgot-passcode');
            }
            return concat(of(forgotPasscodeUserNeedsHelp.loadForgotPasswordsUserNeedsHelpSuccess({ response })));
          }),
          retryTransientHttpErrors(),
          catchError(error => {
            return of(forgotPasscodeUserNeedsHelp.loadForgotPasswordsUserNeedsHelpFailure(error));
          })
        )
      )
    )
  );
}
